// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker-solid';

export const Component = () => (
  <path d='M19 5.355V19.69c0 .394-.136.7-.408.962-.226.218-.589.349-.997.349-.362 0-.633-.088-.86-.262l-5.164-4.196H6.906a.911.911 0 0 1-.634-.262.849.849 0 0 1-.272-.612V9.375c0-.218.09-.437.272-.612a.911.911 0 0 1 .634-.262h4.665l5.163-4.195c.317-.218.634-.306.86-.306.409 0 .726.131.997.394.272.262.408.568.408.961H19Z' />
);

export const viewBox = '0 0 25 25';
